export default {
  UserNotFoundException: '用戶不存在',
  NotAuthorizedException: '密碼錯誤',
  InvalidParameterException: '欄位不完整或是格式錯誤',
};
